import { SearchOutlined } from '@ant-design/icons'
import { Button, Card, Input, Table } from 'antd'
import * as React from 'react'
import { useEffect, useRef, useState } from 'react'
import { ItemResponsePageUrlKeywordsBeanObject, ListPagination, PageUrlKeywordsBean } from 'src/api/api'
import { StorageKey, memoryStorage, storageReaderFactory, storageWriterFactory } from 'src/util/Storage'
import contextualTargetingApi from './ContextualTargetingApi'
import { toSort, useSorter } from 'src/util/useSorter'
import { enumView } from 'src/util/Util'

const Column = Table.Column

const storageWriter = storageWriterFactory('contextualTargeting', memoryStorage)
const storageReader = storageReaderFactory('contextualTargeting', memoryStorage)

interface Props { }

const ContextualTargetingList: React.FC<Props> = () => {

    const [data, setData] = useState<PageUrlKeywordsBean[]>([])
    const [pagination, setPagination] = useState<any>({
        defaultCurrent: 1,
        defaultPageSize: 10,
        current: 1
    })

    const [search, setSearch] = useState<string>()
    const [keyword, setKeyword] = useState<string>()
    const [filters, setFilters] = useState<{ search?: string, keyword?: string }>({})

    const savedParams = storageReader.read(StorageKey.SearchParams)
    const isInitialLoad = useRef(true)

    const loadData = async (page: number) => {

        const response = await contextualTargetingApi.pageUrlKeywords(pagination.defaultPageSize, page, toSort(sorter), filters.search, filters.keyword)

        const array = response.data as Array<ItemResponsePageUrlKeywordsBeanObject>
        const beans: PageUrlKeywordsBean[] = array.map(item => item.data as PageUrlKeywordsBean)

        if (beans.length == 0 && page > 1) {
            loadData(page - 1)
        } else {
            const newPagination: ListPagination = response.pagination as ListPagination
            storageWriter.write(StorageKey.SearchParams, {
                page: newPagination.currentPage
            })

            setData(beans)
            setPagination({ ...pagination, total: newPagination.total, current: newPagination.currentPage })
        }
    }

    const { sorter, handleTableChange } = useSorter(pagination, loadData, 'processedAt')

    useEffect(() => {
        if (isInitialLoad.current) {
            isInitialLoad.current = false
            loadData(savedParams.page || pagination.current)
        } else {
            loadData(1)
        }
    }, [filters, sorter])

    const applyFilters = () => setFilters({ search, keyword })

    const clearFilter = (key: 'search' | 'keyword') => setFilters(f => f[key] === undefined ? f : { ...f, [key]: undefined })

    return <Card
        title="Contextual Targeting"
        className="list-card"
    >
        <div className="list-filter-group">
            <Input allowClear prefix={<SearchOutlined />} placeholder="Search by Page URL" onChange={e => setSearch(e.target.value || undefined)} onPressEnter={applyFilters} onClear={() => clearFilter('search')} />
            <Input allowClear prefix={<SearchOutlined />} placeholder="Search by Keyword" onChange={e => setKeyword(e.target.value || undefined)} onPressEnter={applyFilters} onClear={() => clearFilter('keyword')} />
            <Button type="primary" icon={<SearchOutlined />} onClick={applyFilters}>Search</Button>
        </div>
        <Table
            rowKey="pageUrl"
            size="middle"
            dataSource={data}
            pagination={{ ...pagination, size: 'default' }}
            onChange={handleTableChange}
        >
            <Column key="pageUrl" title="Page URL" dataIndex="pageUrl" />
            <Column key="keywords" title="Keywords" dataIndex="keywords" render={(keywords: string[]) => keywords?.join(', ')} />
            <Column key="brandSafety" title="Brand Safety" dataIndex="brandSafety" render={(brandSafetyList: string[]) => brandSafetyList?.map(enumView).join(', ')} />
            <Column key="processedAt" title="Processed At" dataIndex="processedAt" sorter />
        </Table>
    </Card>
}

export default ContextualTargetingList



// WEBPACK FOOTER //
// ./src/component/app/contextualTargeting/ContextualTargetingList.tsx